import { render, staticRenderFns } from "./AbsencesTableModal.vue?vue&type=template&id=90f2b90e&"
import script from "./AbsencesTableModal.vue?vue&type=script&lang=js&"
export * from "./AbsencesTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports